import {NgClass} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {booleanAttribute, Component, Input, ViewChild} from '@angular/core';
import { ValApiResultat } from '../../../../../val-ammon-services/val-services-communs-lib/src/lib/ValApiResultat';
import { BoiteDialogueGeneriqueComponent } from "../boite-dialogue-generique/boite-dialogue-generique.component";
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';
import { ReleaseNoteResultat } from './ReleaseNoteResultat';
import { SimplePanelComponent } from "../simple-panel/simple-panel.component";

//Composant affichage de la version et des notes de version dans la barre de navigation
@Component (
{
  selector: 'val-barre-navigation-version',
  imports: [
    NgClass,
    BoiteDialogueGeneriqueComponent,
    TranslocoPipe,
    SimplePanelComponent
],
  providers: [
    provideTranslocoScope('valcomposantslib')
  ],
  templateUrl: './barre-navigation-version.component.html',
  styleUrl: './barre-navigation-version.component.scss'
})
export class BarreNavigationVersionComponent 
{
  constructor (private httpClient: HttpClient)
  {
      this.urlApiManifest = "";
      this.versionApplication = "###"
      this.releaseNotes = null;
      this.masquerReleaseNotes = false;
      this.masque = false;
  }

  // URL de l'API manifest (version et notes de version)
  @Input ()
  public urlApiManifest: string;
  
  // Indique si les notes de version doivent être masquées
  @Input ({transform: booleanAttribute})
  public masquerReleaseNotes: boolean;

  //Indique si le libellé est masqué
  @Input ({transform: booleanAttribute})
  public masque: boolean;

  // Version de l’application
  public versionApplication: string | null = null;

  // Notes de version
  public releaseNotes: ReleaseNoteResultat[] | null = null;

  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<void>;

  public ngOnInit (): void
  {
    this.RecupererVersion ();
  }

  private async RecupererVersion()
  {
    let valApiResultat: ValApiResultat<string>;
    try
    {
      valApiResultat = await this.ExecuterRequeteGet<string> ("version");

      if (valApiResultat.status === "success")
        this.versionApplication = valApiResultat.resultat!;
    }
    catch (erreur)
    {
    }
  }

  private async RecupererReleaseNotes()
  {
    if (this.releaseNotes != null)
      return;

    let valApiResultat: ValApiResultat<ReleaseNoteResultat[]>;
    try
    {
      valApiResultat = await this.ExecuterRequeteGet<ReleaseNoteResultat[]> ("release-notes");

      if (valApiResultat.status === "success")
        this.releaseNotes = valApiResultat.resultat!;
    }
    catch (erreur)
    {
    }
  }

  //Exécute une requête GET
  //  Paramètres
  //    url        : Url
  //  Retourne
  //    Résultat de la requête
  protected async ExecuterRequeteGet<T> (url: string) : Promise<ValApiResultat<T>> 
  {
    let operation: Promise<ValApiResultat<T>>;
    let valApiResultat: ValApiResultat<T>;
    let urlApi: string;

    urlApi = `${this.urlApiManifest}/v1.0/${url}`;

    operation = new Promise<ValApiResultat<T>> ((retourReussi, retourErreur) =>
    {
      this.httpClient.get<ValApiResultat<T>> (urlApi).subscribe (
      {
        next: donnees => valApiResultat = donnees,
        error: erreur => retourErreur (erreur),
        complete: () => retourReussi (valApiResultat)
      });
    });

    return operation;
  }

  public NotesClick() {
    this.RecupererReleaseNotes ();
    this.boiteDialogue.Ouvrir();
  }

  public FermerNotes() {
    this.boiteDialogue.Fermer();
  }
}
